import { useLocation, useNavigate } from "react-router-dom";
import { TiArrowBack } from "react-icons/ti";
import "../../../Styles/Livejob.css";

const Employeejobpost = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ RECEIVE JOB DATA
  const job = location.state?.job;

  if (!job) {
    return <p className="text-center mt-5">No job data found</p>;
  }

  return (
    <div className="hrjobpost-wrapper">
      <div className="hrjobpost-card">

        <button className="jobback" onClick={() => navigate(-1)}>
          <TiArrowBack /> Back
        </button>

        <h1 className="Empjptitle">Employee Job Posts</h1>
        <h2 className="hrjobpost-title">JOB PREVIEW</h2>

        <div className="hrjobpost-grid">

          <div className="hrjobpost-field">
            <label>Job Title</label>
            <input value={job.jobTitle} readOnly />
          </div>

          <div className="hrjobpost-field">
            <label>Company Name</label>
            <input value={job.companyname} readOnly />
          </div>

          <div className="hrjobpost-field">
            <label>Department</label>
            <input value={job.department} readOnly />
          </div>

          <div className="hrjobpost-field">
            <label>Work Mode</label>
            <input value={job.workMode} readOnly />
          </div>

          <div className="hrjobpost-field hrjobpost-full">
            <label>Roles & Responsibilities</label>
            <textarea value={job.roles} readOnly />
          </div>

          <div className="hrjobpost-field hrjobpost-full">
            <label>Required Skills</label>
            <textarea value={job.skills?.join(", ")} readOnly />
          </div>

          <div className="hrjobpost-field">
            <label>Qualification</label>
            <input value={job.qualification} readOnly />
          </div>

          <div className="hrjobpost-field">
            <label>Salary Range (LPA)</label>
            <input value={`${job.salaryMin} - ${job.salaryMax}`} readOnly />
          </div>

          <div className="hrjobpost-field hrjobpost-full">
            <label>Perks & Benefits</label>
            <textarea value={job.perks?.join(", ")} readOnly />
          </div>

          <div className="hrjobpost-field">
            <label>Job Location</label>
            <input value={job.jobLocation} readOnly />
          </div>

          <div className="hrjobpost-field">
            <label>Job Locality</label>
            <input value={job.jobLocality} readOnly />
          </div>

          <div className="hrjobpost-field">
            <label>Openings</label>
            <input value={job.openings} readOnly />
          </div>

          <div className="hrjobpost-field">
            <label>Deadline</label>
            <input value={job.deadline} readOnly />
          </div>

          <div className="hrjobpost-field">
            <label>Whatsapp Number</label>
            <input value={job.whtspnumber} readOnly />
          </div>

          {job.attachment && (
            <div className="hrjobpost-field hrjobpost-full">
              <label>Attachment</label>
              {job.attachment.startsWith("data:image") ? (
                <img
                  src={job.attachment}
                  alt="Attachment"
                  style={{ maxWidth: "300px" }}
                />
              ) : (
                <a href={job.attachment} target="_blank" rel="noreferrer">
                  View Document
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Employeejobpost;
